'use client';
import React, { useEffect, useRef, useState } from 'react';

import { cn } from '@/lib/utils';

export function ContactSalesBookingForm() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [, setLoaded] = useState(true);

  // TODO in old we had an loader
  useEffect(() => {
    if (!iframeRef.current) return;

    iframeRef.current.onload = function () {
      setLoaded(true);
    };
  }, []);

  return (
    <iframe
      className={cn('h-full min-h-[650px] w-full')}
      loading='lazy'
      ref={iframeRef}
      src='https://smartproxy.getoutreach.com/calendar/team/t/1#/select-time'
    />
  );
}
